import AuditList from "./AuditList";


function AuditListAdmin () {

    return (
        <AuditList adminMode={true} />
    )
}

export default AuditListAdmin;